export default __webpack_public_path__ + "static/media/ai_color_detectionActive.53b23734.svg";